
export const MsaReceiptStatusType = 
{
    NONE: "NONE",
    TOMRA: "TO-MRA",
    POSTEDTOMRA: "POSTED-TO-MRA",
    TOQA: "TO-QA",
    AWAITQA: "AWAITING-QA",
    RECEIVEDQA: "RECEIVED-QA",
    AWAITDISPOSITION: "AWAIT-DISPOSITION",
    TOAUTOPILOT: "TO-AUTOPILOT",
    AWAITINGFAMOUSRETRY: "AWAITING-FAMOUS-RETRY",
    POSTEDTOFAMOUS: "POSTED-TO-FAMOUS",
    NOLINESTOPOST: "NO-LINES-TO-POST",
    TOPRINTERGNOME: "TO-PRINTERGNOME",
    TAGREPOSTREQUEST: "TAGREPOST-REQUESTED",
    TAGPRINTERROR: "TAGPRINT-ERROR",
    TAGREPRINTREQUEST: "TAGREPRINT-REQUESTED",
    FAMOUSTAGSPRINTED: "FAMOUS-TAGS-PRINTED",
    VOIDED: "VOIDED",
    COMPLETE: "COMPLETE",
    UNEXPECTEDERROR: "UNEXPECTED-ERROR"
}


